module.exports = "pegasus_template/assets/background-patterns/space.png";